import React from 'react';
import classnames from 'classnames';
import TrackVisibility from 'react-on-screen';
import { I18n } from '@fiverr-private/i18n-react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics';
import CloudinaryResponsiveImage from '../../../../shared/components/CloudinaryResponsiveImage';
import { useUserAgentContext } from '../../../../shared/components/UserAgentContext';
import { BLOG_POSTS_CONTENT, INNER_CLASSES } from '../constants';
import { IMAGES_RESOLUTIONS } from './constants';
import './style.scss';

const { reportBlogArticleClicked } = makersExperience.integrationLandingPage;

const BlogPosts = () => {
    const { isMobile, isTablet } = useUserAgentContext();

    const onArticleClick = (articleIndex) => {
        let horizontalPosition = articleIndex + 1;
        if (isMobile) {
            // We have column layout for mobile, and the horizontal position will be 1 all time.
            horizontalPosition = 1;
        }
        if (isTablet) {
            const mobileRowItems = 2;
            const currentRow = Math.floor(articleIndex / mobileRowItems);
            const prevItems = currentRow * mobileRowItems;
            horizontalPosition = horizontalPosition - prevItems;
        }

        const { title } = BLOG_POSTS_CONTENT[articleIndex];
        reportBlogArticleClicked({
            title,
            horizontalPosition,
        });
    };

    return (
        <div className={classnames('blog-posts', INNER_CLASSES)}>
            <h2 className="text-display-2">
                <I18n k="logo_maker_perseus.buyer_landing_page.blog_posts.section_title" />
            </h2>
            <div className="blog-grid grid-12">
                {BLOG_POSTS_CONTENT.map((section, i) => (
                    <TrackVisibility
                        offset={200}
                        once
                        partialVisibility
                        tag="div"
                        className="col-12-xs col-6-sm col-3-lg"
                        key={section.id}
                    >
                        {({ isVisible }) => (
                            <>
                                <a
                                    href={section.link}
                                    target="_blank"
                                    onClick={() => onArticleClick(i)}
                                    rel="noreferrer"
                                >
                                    {isVisible && (
                                        <CloudinaryResponsiveImage
                                            image={section.image}
                                            mediaQueryGrid={IMAGES_RESOLUTIONS}
                                            alt={section.title}
                                        />
                                    )}

                                    <h5>{section.title}</h5>
                                </a>
                                <p>{section.excerpt}</p>
                                <a
                                    href={section.link}
                                    className="read-more"
                                    target="_blank"
                                    onClick={() => onArticleClick(i)}
                                    rel="noreferrer"
                                >
                                    <I18n k="logo_maker_perseus.general.read_more" />
                                </a>
                            </>
                        )}
                    </TrackVisibility>
                ))}
            </div>
        </div>
    );
};

export default BlogPosts;
